import Vue from 'vue'
import moment from 'moment'

// 'MM/DD/YYYY hh:mm'
Vue.filter('date', function (value, format) {
  if (value) {
    return moment(value).format(format)
  }
})

Vue.filter('ellipsis', function (value, length) {
  if (value && value.length > length) {
    return value.substr(0, length) + '...'
  }
  return value
})



// WEBPACK FOOTER //
// ./src/utils/filters.js